import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

import auth from '@/api/auth'

import users from './users.module'
import js_report from './js_report.module'
import fleet from './fleet.module'
import roles from './roles.module'
import permissions from './permissions.module'
import customers from './customers.module'
import warehouses from './warehouses.module'
import settings from './settings.module'
import orders from './orders.module'
import report from './report.module'
import company from './company.module'
import auditlogs from './auditlogs.module'

import itemType from './itemType.module'
import orderType from './orderType.module'

import assets from './assets.module'
import locations from './locations.module'

import masterItem from './masterItem.module'
import orderCategory from './orderCategory.module'
import orderTemplate from './orderTemplate.module'
import s3files from './s3files.module'
import customerPortal from './customerPortal.module.js'

import requestCategory from './requestCategory.module'
import inventory from './inventory.module'
import checkoffTemplates from './checkoffTemplates.module'
import checkoffTypes from './checkoffTypes.module'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        users,
        js_report,
        fleet,
        roles,
        permissions,
        customers,
        warehouses,
        settings,
        orders,
        report,
        auditlogs,
        company,
        orderType,
        itemType,
        assets,
        locations,
        masterItem,
        orderCategory,
        orderTemplate,
        s3files,
        customerPortal,
        requestCategory,
        inventory,
        checkoffTemplates,
        checkoffTypes
    },
    state: {
        user: {},
        rolePermissions: [],
        isAdmin: false,
        token: null,
        baseURL: null,
        user_customers: [],
        expires: null,
    },
    getters: {
        authenticated: state => !!state.token,
        user_permissions: state =>
            (state.rolePermissions || []).filter(x => x.slug).map(x => x.slug),
        isAdmin: state =>
            state.rolePermissions.length > 0 &&
            state.user_customers.length === 0,
        userCustomers: state => state.user_customers.map(x => x.customer),
    },
    mutations: {
        AUTHENTICATE(
            state,
            { token, user, rolePermissions, user_customers, isAdmin, expires }
        ) {
            state.token = token
            state.rolePermissions = rolePermissions || []
            state.user = user
            state.user_customers = user_customers || []
            state.isAdmin = isAdmin
            state.expires = expires
        },

        UNAUTHENTICATE(state) {
            state.token = null
            state.rolePermissions = []
            state.user_customers = []
            state.user = {}
        },
        SET_BASE_URL(state, baseURL) {
            state.baseURL = baseURL
        },
    },
    actions: {
        async getBaseURL({ commit }) {
            try {
                console.log('getBaseURL url', this._vm.$OMSServersUrl)
                const {
                    data: { Items: servers },
                } = await axios.get(this._vm.$OMSServersUrl)
                console.log('getBaseURL data', servers)
                const { host } = window.location
                const { api_server } = servers.find(x => x.web_domain === host)
                console.log('getBaseURL api_server', api_server)
                commit('SET_BASE_URL', api_server)
            } catch (error) {
                console.log('getBaseURL error', error)
                commit('SET_BASE_URL', this._vm.$DefaultApiServer)
            }
        },

        getToken({ commit, dispatch }) {
            try {
                const accessToken = localStorage.getItem('accessToken')
                if (!accessToken) throw new Error('No Token Found')
                const {
                    token,
                    user,
                    rolePermissions,
                    user_customers,
                    expires,
                    isAdmin,
                } = JSON.parse(accessToken)

                axios.defaults.user = user
                axios.defaults.rolePermissions = rolePermissions
                axios.defaults.headers.common['Authorization'] =
                    'Bearer ' + token

                commit('AUTHENTICATE', {
                    token,
                    user,
                    rolePermissions,
                    user_customers,
                    expires,
                    isAdmin,
                })
            } catch (err) {
                console.log('getToken', err)
                dispatch('logout')
            }
        },

        login({ commit }, { email, password }) {
            console.log('email', email)
            console.log('password', password)
            return auth
                .login(email, password)
                .then(resp => {
                    const {
                        token,
                        user,
                        expires,
                        isAdmin,
                        permissions: rolePermissions,
                        customers: user_customers,
                    } = resp.data.success.data
                    console.log('rolePermissions', rolePermissions)
                    console.log('user_customers', user_customers)
                    console.log('login user', user)
                    //let token = data.success.data.token

                    // commit('authenticated', user)
                    axios.defaults.user = user
                    axios.defaults.rolePermissions = rolePermissions
                    axios.defaults.headers.common['Authorization'] =
                        'Bearer ' + token

                    const storeToekn = JSON.stringify({
                        token,
                        user,
                        expires,
                        isAdmin,
                        rolePermissions,
                        user_customers,
                    })

                    localStorage.setItem('accessToken', storeToekn)
                    // localStorage.setItem(
                    //     'rolePermissions',
                    //     JSON.stringify(rolePermissions)
                    // )
                    // localStorage.setItem('accessUser', JSON.stringify(user))
                    //Define The Users Access Permissions
                    // --------------------------------------------------

                    commit('AUTHENTICATE', {
                        token,
                        user,
                        rolePermissions,
                        expires,
                        isAdmin,
                        user_customers,
                    })
                })
                .catch(error => {
                    throw error
                })
        },
        logout({ commit }) {
            localStorage.removeItem('accessToken')
            commit('UNAUTHENTICATE')
        },
    },
})
